// Simple i18n scaffolding — Turkish default, ready for multi-language.
import { createContext, useContext, useState } from "react";

const TR = {
  common: {
    save: "Kaydet", cancel: "İptal", delete: "Sil", edit: "Düzenle",
    create: "Oluştur", search: "Ara", filter: "Filtre", export: "Dışa Aktar",
    print: "Yazdır", excel: "Excel", pdf: "PDF", refresh: "Yenile",
    close: "Kapat", back: "Geri", next: "İleri", previous: "Önceki",
    loading: "Yükleniyor...", empty: "Kayıt bulunamadı", error: "Hata",
    success: "Başarılı", confirm: "Onayla", yes: "Evet", no: "Hayır",
    total: "Toplam", subtotal: "Ara Toplam", tax: "KDV", grandTotal: "Genel Toplam",
    date: "Tarih", amount: "Tutar", status: "Durum", actions: "İşlemler",
    all: "Tümü", selected: "seçili", page: "Sayfa", perPage: "Sayfa başına",
    of: "/", showColumns: "Kolonlar", download: "İndir", upload: "Yükle",
    dragDrop: "Dosyayı buraya sürükleyin veya seçin",
    unauthorized: "Bu işlem için yetkiniz yok",
  },
  nav: {
    dashboard: "Kontrol Paneli",
    finance: "Finans",
      invoices: "Faturalar", receipts: "Tahsilatlar", payments: "Ödemeler",
      cheques: "Çekler", parties: "Cari Kartlar",
    banking: "Bankacılık",
      banks: "Bankalar", bankAccounts: "Banka Hesapları",
      cashRegisters: "Kasa", creditCards: "Kredi Kartları", dbs: "DBS",
    accounting: "Muhasebe",
      accounts: "Hesap Planı", journals: "Yevmiye", trialBalance: "Mizan",
    automation: "Otomasyon",
      subscriptions: "Abonelikler", reminders: "Hatırlatmalar",
    reports: "Raporlar",
      aging: "Yaşlandırma", vat: "KDV Özeti",
    attachments: "Dosya Ekleri",
    settings: "Ayarlar",
  },
  auth: {
    login: "Giriş Yap", logout: "Çıkış Yap", email: "E-posta",
    password: "Şifre", welcome: "Hoş Geldiniz",
    tagline: "Has Yapı Finans Yönetim Sistemi",
    signInMessage: "Hesabınıza giriş yapın",
  },
  status: {
    unpaid: "Ödenmedi", partial: "Kısmi", paid: "Ödendi",
    overdue: "Gecikmiş", cancelled: "İptal", draft: "Taslak", posted: "İşlenmiş",
    pending: "Bekliyor", done: "Tamamlandı", dismissed: "İptal",
    portfolio: "Portföyde", deposited: "Bankada", cleared: "Tahsil Edildi",
    bounced: "Karşılıksız", handed_over: "Teslim Edildi",
    returned: "İade", active: "Aktif", suspended: "Askıda",
  },
};

const dictionaries = { tr: TR };

const I18nContext = createContext({ lang: "tr", t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState("tr");
  const dict = dictionaries[lang] || dictionaries.tr;
  const t = (key) => {
    const parts = key.split(".");
    let node = dict;
    for (const p of parts) {
      if (node && typeof node === "object" && p in node) node = node[p];
      else return key;
    }
    return typeof node === "string" ? node : key;
  };
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useT = () => useContext(I18nContext);
